import { apiSlice } from "./apiSlice";
import { RENEWAL_URL } from "../constants";

const renewalsApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getRenewals: builder.query({
      query: (body) => ({
        url: `${RENEWAL_URL}${body.query ? body.query : ""}`,
        headers: {
          Authorization: `Bearer ${body.token}`,
        },
      }),
      keepUnusedDataFor: 5,
    }),
  }),
});

export const { useGetRenewalsQuery } = renewalsApiSlice;
